import { getGroupAuthType } from "../redux/actions/auth";
import { GROUP_AUTH_HEADER_NAME } from "../constants/axios";
import { httpAuth } from "../utils/axios";

const OmnisearchQuestions = {
  fetch_provider_schedule_call_list: function ({ options } = {}) {
    /** if { queryParams not passed i.e no arguments, then assigning empty object `{}`} */
    let url = "/v1/search/omnisearch_questions";
    let conf = {
      url,
      method: "post",
      ...options,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
    };

    return httpAuth(conf);
  },

  answerOmnisearch: function (omnisearchQuestion) {
    let url = "/v1/search/omnisearch_answer";
    let conf = {
      url,
      method: "post",
      data: omnisearchQuestion,
      headers: { [GROUP_AUTH_HEADER_NAME]: getGroupAuthType() },
    };

    return httpAuth(conf);
  },
};

export default OmnisearchQuestions;
